import { StackScreenProps } from "@react-navigation/stack";
import { FlatActionList, Page } from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { LlmStrategyFormValues } from "../../components/LlmStrategyForm";
import { useFormContext } from "react-hook-form";
import { View } from "react-native";
import { GeminiModels } from "./common";
import { Feather } from "@expo/vector-icons";
import { Colors } from "react-native-ui-lib";

export interface SelectGeminiModelScreenProps
  extends StackScreenProps<any, "SelectGeminiModelScreen"> {}

export const SelectGeminiModelScreen = ({
  navigation,
}: SelectGeminiModelScreenProps) => {
  const { t } = useTranslation("settings");
  const { getValues, setValue } = useFormContext<LlmStrategyFormValues>();
  const watchedKeyType = getValues("geminiConfig.geminiModel");
  const handleOnSelect = (code: string) => {
    setValue("geminiConfig.geminiModel", code, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    navigation.goBack();
  };
  return (
    <Page
      title={t("title.select_gemini_model")}
      secondaryTitle={t("title.select_gemini_model_secondary")}
    >
      <View>
        <FlatActionList
          items={GeminiModels.map((llmType) => ({
            key: llmType.value,
            title: llmType.label,
            subTitle: llmType.description,
            selected: llmType.value === watchedKeyType,
            onPress: () => {
              handleOnSelect(llmType.value);
            },
          }))}
        />
      </View>
    </Page>
  );
};
